/* eslint-disable import/prefer-default-export */
export const GET_PLANS_ERROR_MESSAGE = 'Error getting available plans. Please try again.';
export const GET_CURRENT_PLAN_ERROR_MESSAGE = 'Error getting current plan. Please try again.';
export const GET_USER_CARDS_ERROR_MESSAGE = 'Error getting user cards.';
export const SAVE_NEW_CARD_ERROR_MESSAGE = 'There was an error saving the new card. Please try again or contact support.';
export const CONFIRM_CHANGE_PAYPAL_ERROR = 'There was an error paying with your PayPal account. Please try again or contact support.';
export const CONFIRM_CHANGE_ERROR = 'There was an error changing your plan. Please try again or contact support.';

export const getStripeScriptUrl = () => 'https://js.stripe.com/v3/';
export const getPayPalScriptUrl = (key) => `https://www.paypal.com/sdk/js?client-id=${key}&debug=false&disable-funding=card,credit,paylater&intent=authorize`;

export const REDUCE_TIER_REQUEST = 'reduce_tier';
export const ENHANCE_TIER_REQUEST = 'enhance_tier';
export const STRIPE_ELEMENT_SLUG = 'stripe-elements';

// Steps of the upgrade/downgrade plan flow.
export const STEPS = [
  {
    label: 'Select tier',
    key: 'select-tier',
  },
  {
    label: 'Billing information',
    key: 'billing-details',
  },
  {
    label: 'Payment',
    key: 'select-payment',
  },
  {
    label: 'Review',
    key: 'review',
  },
];

// Available payment methods shown in the flow.
export const PAYMENT_METHODS = [
  {
    key: 'credit-card-new',
    label: 'Credit or debit card',
  },
  {
    key: 'paypal',
    label: 'PayPal',
  },
  {
    key: 'credits',
    label: 'AppSumo credits',
  },
];

// List of countries that user can choose from when creating a new card.
export const CARD_COUNTRIES = [
  {
    name: 'United States',
    value: 'US',
  },
  {
    name: 'Canada',
    value: 'CA',
  },
  {
    name: 'Other',
    value: '',
  },
];

/* eslint-disable global-require */
export const STRIPE_ELEMENTS_PAYMENT_OPTIONS = {
  card: {
    imgSrc: require('~/static/payment-methods/generic-card.svg'),
    label: 'Credit card',
  },
  afterpay: {
    imgSrc: require('~/static/payment-methods/afterpay.svg'),
    label: 'Afterpay',
  },
  wechat_pay: {
    imgSrc: require('~/static/payment-methods/wechat.svg'),
    label: 'WeChat Pay',
  },
  klarna: {
    imgSrc: require('~/static/payment-methods/klarna.svg'),
    label: 'Klarna',
  },
  us_bank_account: {
    imgSrc: require('~/static/payment-methods/us-bank.svg'),
    label: 'Bank',
  },
  google_pay: {
    imgSrc: require('~/static/payment-methods/gpay.svg'),
    label: 'Google Pay',
  },
  apple_pay: {
    imgSrc: require('~/static/payment-methods/applepay.svg'),
    label: 'Apple Pay',
  },
};
/* eslint-enable global-require */
